// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/icons/right-arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/icons/up-arrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
    width: 300px;
    background: var(--grey);
    height: 100vh;
}

.sidebarLogo {
    width: 65px;
    padding: 5px;
    background: var(--white);
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
}

.sideBarMiddleCotainer {
    height: calc(100vh - 200px);
    overflow: auto;
}

.sidebarBottom {
    background: #48595f;
    width: 90%;
    padding: 10px 10px 10px 20px;
}

.menuBtn.accordion {
    /* padding: 10px 10px 3px 20px; */
    color: #afafaf;
    background: #1f1f1f;
}

.menuBtn.accordion .accordion-item {
    border-bottom: none;
}

.menuBtn:hover {
    color: var(--white);
}

.menuBtn h1 {
    color: var(--white);
    font-weight: 700;
}

.menuBtn ul {
    list-style: none;
    padding: 0;
    width: 100%;
}

.menuBtn ul li {
    color: #ffff;
    width: 100%;
    padding: 10px 25px;
    border-left: solid 6px var(--grey);
    cursor: pointer;
    border-radius: 0 10px 10px 0;
    font-weight: 700;
}

.menuBtn ul li:hover {
    background-color: #363b46;
    color: var(--theme2);
    border-left: solid 6px var(--theme2);
}

.menuBtn ul li.active {
    background-color: #363b46;
    color: var(--theme2);
    border-left: solid 6px var(--theme2);
}

.menuBtn .accordion-button {
    color: #ffff;
    width: 100%;
    padding: 10px 25px;
    border-left: solid 6px var(--grey);
    cursor: pointer;
    border-radius: 0 10px 10px 0;
    font-weight: 700;
    background: var(--grey);
    font-size: 14px;
}

.menuBtn .accordion-button:hover {
    background-color: #363b46;
    color: var(--theme2);
    border-left: solid 6px var(--theme2);
}

.menuBtn .accordion-button.active {
    background-color: #363b46;
    color: var(--theme2);
    border-left: solid 6px var(--theme2);
}

.menuBtn .accordion-button:not(.collapsed) {
    background-color: #363b46;
    color: var(--theme2);
    border-left: solid 6px var(--theme2);
    box-shadow: none;
}

.menuBtn .accordion-button::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    transition: var(--bs-accordion-btn-icon-transition);
}

.menuBtn .accordion-button:not(.collapsed)::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    transform: var(--bs-accordion-btn-icon-transform);
}

.menuBtn .accordion-body {
    background: var(--grey);
    border-top: solid 1px #69768f;
    border-bottom: solid 1px #69768f;
}

.subMenuBtn ul li {
    color: #fff;
    width: 90%;
    padding: 6px 25px;
    border-left: solid 6px var(--grey);
    cursor: pointer;
    border-radius: 0 10px 10px 0;
    font-weight: lighter;
}

.subMenuBtn ul li:hover {
    background-color: #363b46;
    color: var(--theme2);
    border-left: solid 6px var(--theme2);
}

.subMenuBtn ul li.active {
    background-color: #363b46;
    color: var(--theme2);
    border-left: solid 6px var(--theme2);
}

@media screen and (max-width: 1024px) {
    .sidebar {
        width: 30%;
        height: 100vh;
        transition: all 0.3s ease;
        position: fixed;
        z-index: 1000;
    }
    .sidebar.responisveDiv {
        transform: translateX(-100%);
    }
    .sidebarLogo {
        width: 55px;
    }
    .menuBtn ul li,
    .subMenuBtn ul li {
        padding: 10px;
        font-size: 12px;
    }
}

@media screen and (max-width: 768px) {
    .sidebar {
        width: 220px;
        height: 100vh;
        transition: all 0.3s ease;
        position: fixed;
        z-index: 1000;
    }
    .sidebar.responisveDiv {
        transform: translateX(-100%);
    }
    .sidebarLogo {
        width: 55px;
    }
    .menuBtn ul li,
    .subMenuBtn ul li {
        padding: 10px;
        font-size: 12px;
    }
}

@media screen and (max-width: 576px) {
    .sidebar {
        width: 60%;
        height: 100%;
        transition: all 0.3s ease;
        position: fixed;
        z-index: 1000;
    }

    .sidebar.responisveDiv {
        transform: translateX(-100%);
    }

    .menuBtn ul li,
    .subMenuBtn ul li {
        font-size: 12px;
    }
}

.toggleButton {
    position: fixed;
    top: 15px;
    left: 15px;
    z-index: 1100;
    background: var(--theme1);
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
    display: none;
    color: var(--white);
}

.closeMenu {
    position: fixed;
    top: 5px;
    left: 46%;
    z-index: 1100;
    background: var(--theme1);
    padding: 8px;
    border-radius: 50%;
    cursor: pointer;
    display: none;
    color: var(--white);
    transition: all 0.3s ease;
}

@media screen and (max-width: 1024px) {
    .toggleButton,
    .closeMenu {
        display: block;
    }
    .closeMenu {
        left: 28%;
    }
}

@media screen and (max-width: 768px) {
    .toggleButton,
    .closeMenu {
        display: block;
    }
}

@media screen and (max-width: 576px) {
    .toggleButton,
    .closeMenu {
        display: block;
    }
    .closeMenu {
        left: 55%;
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,iCAAiC;IACjC,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,yDAAwD;IACxD,mDAAmD;AACvD;;AAEA;IACI,yDAAqD;IACrD,iDAAiD;AACrD;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,kCAAkC;IAClC,eAAe;IACf,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,aAAa;QACb,yBAAyB;QACzB,eAAe;QACf,aAAa;IACjB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,WAAW;IACf;IACA;;QAEI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,eAAe;QACf,aAAa;IACjB;IACA;QACI,4BAA4B;IAChC;IACA;QACI,WAAW;IACf;IACA;;QAEI,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,YAAY;QACZ,yBAAyB;QACzB,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI;;QAEI,cAAc;IAClB;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;;QAEI,cAAc;IAClB;AACJ;;AAEA;IACI;;QAEI,cAAc;IAClB;IACA;QACI,SAAS;IACb;AACJ","sourcesContent":[".sidebar {\n    width: 300px;\n    background: var(--grey);\n    height: 100vh;\n}\n\n.sidebarLogo {\n    width: 65px;\n    padding: 5px;\n    background: var(--white);\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n}\n\n.sideBarMiddleCotainer {\n    height: calc(100vh - 200px);\n    overflow: auto;\n}\n\n.sidebarBottom {\n    background: #48595f;\n    width: 90%;\n    padding: 10px 10px 10px 20px;\n}\n\n.menuBtn.accordion {\n    /* padding: 10px 10px 3px 20px; */\n    color: #afafaf;\n    background: #1f1f1f;\n}\n\n.menuBtn.accordion .accordion-item {\n    border-bottom: none;\n}\n\n.menuBtn:hover {\n    color: var(--white);\n}\n\n.menuBtn h1 {\n    color: var(--white);\n    font-weight: 700;\n}\n\n.menuBtn ul {\n    list-style: none;\n    padding: 0;\n    width: 100%;\n}\n\n.menuBtn ul li {\n    color: #ffff;\n    width: 100%;\n    padding: 10px 25px;\n    border-left: solid 6px var(--grey);\n    cursor: pointer;\n    border-radius: 0 10px 10px 0;\n    font-weight: 700;\n}\n\n.menuBtn ul li:hover {\n    background-color: #363b46;\n    color: var(--theme2);\n    border-left: solid 6px var(--theme2);\n}\n\n.menuBtn ul li.active {\n    background-color: #363b46;\n    color: var(--theme2);\n    border-left: solid 6px var(--theme2);\n}\n\n.menuBtn .accordion-button {\n    color: #ffff;\n    width: 100%;\n    padding: 10px 25px;\n    border-left: solid 6px var(--grey);\n    cursor: pointer;\n    border-radius: 0 10px 10px 0;\n    font-weight: 700;\n    background: var(--grey);\n    font-size: 14px;\n}\n\n.menuBtn .accordion-button:hover {\n    background-color: #363b46;\n    color: var(--theme2);\n    border-left: solid 6px var(--theme2);\n}\n\n.menuBtn .accordion-button.active {\n    background-color: #363b46;\n    color: var(--theme2);\n    border-left: solid 6px var(--theme2);\n}\n\n.menuBtn .accordion-button:not(.collapsed) {\n    background-color: #363b46;\n    color: var(--theme2);\n    border-left: solid 6px var(--theme2);\n    box-shadow: none;\n}\n\n.menuBtn .accordion-button::after {\n    background-image: url('../Images/icons/right-arrow.png');\n    transition: var(--bs-accordion-btn-icon-transition);\n}\n\n.menuBtn .accordion-button:not(.collapsed)::after {\n    background-image: url('../Images/icons/up-arrow.png');\n    transform: var(--bs-accordion-btn-icon-transform);\n}\n\n.menuBtn .accordion-body {\n    background: var(--grey);\n    border-top: solid 1px #69768f;\n    border-bottom: solid 1px #69768f;\n}\n\n.subMenuBtn ul li {\n    color: #fff;\n    width: 90%;\n    padding: 6px 25px;\n    border-left: solid 6px var(--grey);\n    cursor: pointer;\n    border-radius: 0 10px 10px 0;\n    font-weight: lighter;\n}\n\n.subMenuBtn ul li:hover {\n    background-color: #363b46;\n    color: var(--theme2);\n    border-left: solid 6px var(--theme2);\n}\n\n.subMenuBtn ul li.active {\n    background-color: #363b46;\n    color: var(--theme2);\n    border-left: solid 6px var(--theme2);\n}\n\n@media screen and (max-width: 1024px) {\n    .sidebar {\n        width: 30%;\n        height: 100vh;\n        transition: all 0.3s ease;\n        position: fixed;\n        z-index: 1000;\n    }\n    .sidebar.responisveDiv {\n        transform: translateX(-100%);\n    }\n    .sidebarLogo {\n        width: 55px;\n    }\n    .menuBtn ul li,\n    .subMenuBtn ul li {\n        padding: 10px;\n        font-size: 12px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .sidebar {\n        width: 220px;\n        height: 100vh;\n        transition: all 0.3s ease;\n        position: fixed;\n        z-index: 1000;\n    }\n    .sidebar.responisveDiv {\n        transform: translateX(-100%);\n    }\n    .sidebarLogo {\n        width: 55px;\n    }\n    .menuBtn ul li,\n    .subMenuBtn ul li {\n        padding: 10px;\n        font-size: 12px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .sidebar {\n        width: 60%;\n        height: 100%;\n        transition: all 0.3s ease;\n        position: fixed;\n        z-index: 1000;\n    }\n\n    .sidebar.responisveDiv {\n        transform: translateX(-100%);\n    }\n\n    .menuBtn ul li,\n    .subMenuBtn ul li {\n        font-size: 12px;\n    }\n}\n\n.toggleButton {\n    position: fixed;\n    top: 15px;\n    left: 15px;\n    z-index: 1100;\n    background: var(--theme1);\n    padding: 8px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: none;\n    color: var(--white);\n}\n\n.closeMenu {\n    position: fixed;\n    top: 5px;\n    left: 46%;\n    z-index: 1100;\n    background: var(--theme1);\n    padding: 8px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: none;\n    color: var(--white);\n    transition: all 0.3s ease;\n}\n\n@media screen and (max-width: 1024px) {\n    .toggleButton,\n    .closeMenu {\n        display: block;\n    }\n    .closeMenu {\n        left: 28%;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .toggleButton,\n    .closeMenu {\n        display: block;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .toggleButton,\n    .closeMenu {\n        display: block;\n    }\n    .closeMenu {\n        left: 55%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
